const CheckAnalysisIcon = ({ size = 56, className = "", isActive = false, ...props }) => {
  const fillColor = isActive ? "#68D7FF" : "#9EA6B2";
  const pathFill = isActive ? "#01BBFE" : "white";
  const gradientId = isActive ? "blueGradient" : "whiteGradient";
  const stopColor = isActive ? "#68D7FF" : "white";

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <rect x="1" y="1" width="54" height="54" rx="27" fill={fillColor} fillOpacity="0.3" />
      <rect x="1" y="1" width="54" height="54" rx="27" stroke={`url(#${gradientId})`} strokeWidth="2" />
      <path
        d="M35.6966 26.3301C35.6966 28.3935 35.0225 30.3223 33.8539 31.8474L39.5618 37.5441C40.1461 38.0824 40.1461 39.0244 39.5618 39.5627C39.0225 40.1458 38.0787 40.1458 37.5393 39.5627L31.8315 33.8659C30.3034 35.0322 28.3708 35.6602 26.3483 35.6602C21.1798 35.6602 17 31.4885 17 26.3301C17 21.2165 21.1798 17 26.3483 17C31.4719 17 35.6966 21.2165 35.6966 26.3301ZM21.6742 29.5597C21.6742 30.1877 22.1236 30.6363 22.7528 30.6363C23.3371 30.6363 23.8315 30.1877 23.8315 29.5597V26.6889C23.8315 26.1058 23.3371 25.6124 22.7528 25.6124C22.1236 25.6124 21.6742 26.1058 21.6742 26.6889V29.5597ZM25.2697 29.5597C25.2697 30.1877 25.7191 30.6363 26.3483 30.6363C26.9326 30.6363 27.427 30.1877 27.427 29.5597V22.3827C27.427 21.7996 26.9326 21.3062 26.3483 21.3062C25.7191 21.3062 25.2697 21.7996 25.2697 22.3827V29.5597ZM28.8652 29.5597C28.8652 30.1877 29.3146 30.6363 29.9438 30.6363C30.5281 30.6363 31.0225 30.1877 31.0225 29.5597V25.2535C31.0225 24.6704 30.5281 24.177 29.9438 24.177C29.3146 24.177 28.8652 24.6704 28.8652 25.2535V29.5597Z"
        fill={pathFill}
      />
      <defs>
        <linearGradient id={gradientId} x1="3.95" y1="4.4" x2="50.76" y2="54.45" gradientUnits="userSpaceOnUse">
          <stop stopColor={stopColor} />
          <stop offset="1" stopColor={stopColor} stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default CheckAnalysisIcon;
